export { default as ban } from './ban'
export { default as declaration } from './declaration'
export { default as profile } from './profile'
export { default as timeline } from './timeline'
export { default as app } from './app'

export const title = 'Gestion des utilisateurs'
